export const serviceConstants = {
  SERVICES_LOADED: 'SERVICES_LOADED',
  SERVICE_CREATED: 'SERVICE_CREATED',
  SERVICE_UPDATED: 'SERVICE_UPDATED',
  SERVICE_DELETED: 'SERVICE_DELETED',
  SERVICE_RESET: 'SERVICE_RESET',
  SERVICE_ERRORS: 'SERVICE_ERRORS',
};



// WEBPACK FOOTER //
// ./src/_constants/service.constants.js